import React from 'react';
import { MdKeyboardArrowUp, MdKeyboardArrowDown } from 'react-icons/md';
import { Flex, Box, Heading, Collapse, useDisclosure } from '@chakra-ui/react';

interface CollapsibleItemProps {
  title: string;
  content: string | React.ReactNode;
  isUnderlined?: boolean;
  isInitiallyOpen?: boolean;
}

const CollapsibleItem = ({
  title,
  content,
  isUnderlined,
  isInitiallyOpen = false,
}: CollapsibleItemProps) => {
  const { isOpen, onToggle } = useDisclosure({
    defaultIsOpen: isInitiallyOpen,
  });

  return (
    <Box
      my="7"
      borderBottomWidth="thin"
      borderBottomColor={isUnderlined ? 'gray.350' : undefined}
    >
      <Flex
        justifyContent="space-between"
        alignItems="center"
        cursor="pointer"
        onClick={onToggle}
      >
        <Heading my="4" fontSize="xl" paddingBottom="4">
          {title}
        </Heading>
        <Box marginLeft="7">
          {isOpen ? (
            <MdKeyboardArrowUp size="30" />
          ) : (
            <MdKeyboardArrowDown size="30" />
          )}
        </Box>
      </Flex>
      <Collapse in={isOpen} animateOpacity>
        <Box mb="7" mr="7">
          {content}
        </Box>
      </Collapse>
    </Box>
  );
};

const CollapsibleItems = ({
  items,
  isUnderlined,
  isInitiallyOpen = false,
}: {
  items: CollapsibleItemProps[];
  isUnderlined?: boolean;
  isInitiallyOpen?: boolean;
}) => (
  <Box>
    {items.map(({ title, content }) => (
      <CollapsibleItem
        title={title}
        content={content}
        key={title}
        isUnderlined={isUnderlined}
        isInitiallyOpen={isInitiallyOpen}
      />
    ))}
  </Box>
);

CollapsibleItem.defaultProps = { isUnderlined: false, isInitiallyOpen: false };
CollapsibleItems.defaultProps = { isUnderlined: false, isInitiallyOpen: false };

export default CollapsibleItems;
